import DashboardLegalAssistant from './DashboardLegalAssistant';

export default DashboardLegalAssistant;
